import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Home, User, Calendar, Loader2, Bot, Star } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { getProspect } from '../lib/inspectionService';
import { useAuth } from "../AuthContext";
import { useParams } from 'react-router-dom';

import './Prospect.css';

const Prospect = () => {
    // Sample data - replace with your backend data
    const [chat, setChat] = useState([]);
    const [loading, setLoading] = useState(true);
    const { userId } = useAuth();
    const { prospectId } = useParams();


    useEffect(() => {
        fetchProspects();
    }, []);

    const fetchProspects = async () => {
        try {
            // Simulate API call with setTimeout
            const data = await getProspect(userId, prospectId);

            // Example data - replace this with your actual API call
            setChat(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching properties:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-[200px]">
                <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
            </div>
        );
    }

    const getCardContent = (chat) => {
        if (chat.status !== 2) {
            return (
                <div className="grid gap-4">
                    SMS sent, no response yet
                </div>
            );
        } else {
            const chatHistory = chat.history.split('\r\n').map((message) => {
                return <div>
                    <span>{message.role}</span>
                    <span>{message.content}</span>
                </div>;
            });

            return (
                <div>
                    <div className="grid gap-4 card-content-header">
                        <span>Chat summary</span>
                    </div>
                    <div className="grid gap-4">
                        <span>{chat.summary}</span>
                    </div>

                    <div className="grid gap-4 card-content-header">
                        <span>Chat history</span>
                    </div>
                    <div className="mt-4 space-y-2 chat-history">
                        {JSON.parse(chat.history).map((message, index) => (
                            <div key={index} className="p-2 bg-gray-100 rounded flex items-center">
                                <span>{message.role !== 'user' ? <Bot className="mr-2" color="red" /> : <User className="mr-2" color="#334433" />}</span>
                                <span>{message.content}</span>
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

    };

    return (
        <div className="container mx-auto px-6 py-8">
            <div className="flex justify-between items-center mb-8">
                <span>
                Customer {chat.Prospect.name} responded to <a href={`/properties/${chat.Property.id}/prospects`} className='link'>{chat.Property.address}</a>
                </span>
            </div>

            <div className="grid gap-6">
                <Card className="hover:shadow-lg transition-shadow">
                    <CardHeader className='card-header'>
                        <CardTitle className="flex justify-between items-start">
                            <span>{chat.Prospect.name}<a className='phone' href={`tel:${chat.Prospect.phone}`}>{chat.Prospect.phone}</a></span>
                            {chat.score && <div className="flex items-center gap-2">
                                <Star className="w-4 h-4" color='red'/>
                                <span>{chat.score}/10</span>
                            </div>}

                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        {getCardContent(chat)}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default Prospect;